angular.module('PatientApp').controller('RedirectCtrl', ['$rootScope', '$scope', '$filter', '$log', 'SsoService', 'AuthService', '$state',
function($rootScope, $scope, $filter, $log, SsoService, AuthService, $state) {
    $scope.showRedirectModal = false;
    $scope.timesUp = false;

    $rootScope.$on('redirect:modal', function () {
        $scope.showRedirectModal = true;
    });

    $rootScope.$on('redirect:tab', function (event, options) {
        $scope.url = options.provider.brandedWalletUrl + '/#/redirect';
        $scope.delaySeconds = options.delaySeconds || 3;

        $scope.newTab = open($scope.url, '_blank');

        var request = {
            providerId: options.provider.id,
            context: options.context || {}
        };

        SsoService.getToken(request).then(function(token){
            $scope.ssoUrl = options.provider.brandedWalletUrl + '/#/sso/token/' + token;
            $scope.tokenRedirect();
        });

        setTimeout(function () {
            $scope.timesUp = true;
            $scope.tokenRedirect();
        }, 1000 * $scope.delaySeconds);
    });

    $scope.tokenRedirect = function() {
        if ($scope.timesUp && $scope.ssoUrl) {
            $scope.newTab.location.replace($scope.ssoUrl);
            $scope.timesUp = false;
            $scope.ssoUrl = null;
        }
    };

    $rootScope.$on('redirect:complete', function (event, options) {
        AuthService.fetchAuthenticatedUser().then(function() {
            if (options.stateGo) {
                var toParams = options.stateGo.toParams || {};
                toParams.callback = function() {
                    $scope.showRedirectModal = false;
                };
                $state.go(options.stateGo.to, toParams, options.stateGo.options || {});
            }
        });
    });
}]);